



import Vue from 'vue'
export default Vue.extend({
  name: "loading",
  props: {
    loading: {
      type: Boolean,
      default: false
    }
  }
});
